var styleDataHash = "b0c58270";
const injectCss = () => {
  var css = `.N-DXP{max-width:30px}[dir=ltr] .N-DXP{animation-delay:0s;animation-duration:2s;animation-iteration-count:infinite;animation-name:uiwlU;animation-timing-function:linear}[dir=rtl] .N-DXP{animation-delay:0s;animation-duration:2s;animation-iteration-count:infinite;animation-name:dDM9j;animation-timing-function:linear}.N-DXP circle{display:block;fill:transparent;stroke:#484848;stroke-linecap:round;stroke-dasharray:283;stroke-dashoffset:280;stroke-width:5px}[dir] .N-DXP circle{transform-origin:50% 50%}[dir=ltr] .N-DXP circle{animation-delay:0s;animation-duration:1.4s;animation-fill-mode:both;animation-iteration-count:infinite;animation-name:_2ZvAE;animation-timing-function:ease-in-out}[dir=rtl] .N-DXP circle{animation-delay:0s;animation-duration:1.4s;animation-fill-mode:both;animation-iteration-count:infinite;animation-name:OaTLK;animation-timing-function:ease-in-out}@keyframes uiwlU{0%{transform:rotate(0deg)}to{transform:rotate(1turn)}}@keyframes dDM9j{0%{transform:rotate(0deg)}to{transform:rotate(-1turn)}}@keyframes _2ZvAE{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(45deg)}to{stroke-dashoffset:280;transform:rotate(1turn)}}@keyframes OaTLK{0%,25%{stroke-dashoffset:280;transform:rotate(0)}50%,75%{stroke-dashoffset:75;transform:rotate(-45deg)}to{stroke-dashoffset:280;transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var spinner_default = {
  "spinner": "N-DXP",
  "spinner-animation-ltr": "uiwlU",
  "spinner-animation-rtl": "dDM9j",
  "circle-animation-ltr": "_2ZvAE",
  "circle-animation-rtl": "OaTLK"
};
export {
  spinner_default as default,
  injectCss
};
//# sourceMappingURL=spinner-scss.js.map
